import React from 'react';
import { Form } from 'react-bootstrap';

import { FormProvider, useForm, useFormContext } from 'react-hook-form';
import { BankDataForm } from './BankDataForm';
import { FormWrapper, LoadingCard } from '@odmonorepo/core-components';
import * as yup from 'yup';
import { useDetailedOffers } from 'merchant-api/offer';
import { useApplication } from 'merchant-api/unified';

export interface BankDataProps {
  type: 'LOC' | 'TL';
}

const BankDataSchema = yup.object().shape({
  routingNumber: yup.string()
    .required('formInput.routingNumber.required')
    .test(
      'routingNumber.error',
      'formInput.routingNumber.invalid',
      (value) => {
        if (value === undefined || value === null || value === '') return true;
        return /^\d{9}$/.test(value);
      }
    ),
  accountNumber: yup.string()
    .required('formInput.accountNumber.required')
    .test(
      'accountNumber.error',
      'formInput.accountNumber.invalid',
      (value) => {
        if (value === undefined || value === null || value === '') return true;
        return /^\d{6,17}$/.test(value);
      }
    ),
  accountNumberConfirmation: yup.string()
    .required('formInput.accountNumberConfirmation.required')
    .test(
      'accountNumberConfirmation.error',
      'formInput.accountNumberConfirmation.invalid',
      (value) => {
        if (value === undefined || value === null || value === '') return true;
        return /^\d{6,17}$/.test(value);
      }
    )
    .test(
      'accountNumberConfirmation.match',
      'formInput.accountNumber.nonMatch',
      (value, context) => value === context.parent.accountNumber
    ),
})


export const BankData = () => {
  const { selectedOffer, isLoadingDetailedOffers } = useDetailedOffers();
  const { applicationId, isLoadingApplication } = useApplication();
  if (isLoadingDetailedOffers || isLoadingApplication) {
    return <LoadingCard />;
  }
  return (
    <FormWrapper schema={BankDataSchema}>
        <BankDataForm selectedOffer={selectedOffer} applicationId={applicationId} />
    </FormWrapper>
  );
};

export default BankData;